
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"35","height":"33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.25 32.583V28.75h23v3.833h-23zm24.917-13.416c-2.652 0-4.912-.935-6.78-2.804-1.87-1.868-2.804-4.128-2.804-6.78 0-2.651.935-4.911 2.804-6.78C20.255.934 22.515 0 25.167 0c2.651 0 4.911.934 6.78 2.803 1.869 1.869 2.803 4.129 2.803 6.78 0 2.652-.934 4.912-2.803 6.78-1.869 1.87-4.129 2.804-6.78 2.804zM.25 17.25v-3.833h12.075c.224.702.48 1.373.767 2.012.287.64.639 1.246 1.054 1.821H.25zm0 7.667v-3.834h18.017a13.24 13.24 0 002.348 1.126c.83.304 1.709.52 2.635.647v2.06h-23zM24.208 11.5h1.917V3.833h-1.917V11.5zm.959 3.833a.92.92 0 00.67-.287.919.919 0 00.288-.671.919.919 0 00-.288-.67.92.92 0 00-.67-.288.92.92 0 00-.671.287.92.92 0 00-.288.671c0 .256.096.48.288.67a.92.92 0 00.67.288z","fill":"#a3a3a3"}})])
          )
        }
      }
    